<template>
    <div class="block hzdw" id="hzdw">
        <div class="itemTitBox wow animated bounceInRight">
            <p class="big">合作单位</p>
            <p class="small">CONSTITUTION</p>
        </div>
        <div class="dhxq wow animated bounceInLeft">
            <div class="dhxqItem wow animated fadeInUp">
                <p class="title">合作社区</p>
                <!-- <div class="triangle_icon"> -->
                <img class="triangle_icon" src="../assets/images/triangle_icon.png" alt="" />
                <!-- </div> -->
                <div class="dhxqTxt">
                    <div class="imgBox" v-for="(item, index) in dataJson.hzsq" :key="index">
                        <img class="img" :src="item" alt="">
                    </div>
                </div>
            </div>
            <div class="dhxqItem wow animated fadeInUp">
                <p class="title">合作媒体</p>
                <img class="triangle_icon" src="../assets/images/triangle_icon.png" alt="" />
                <div class="dhxqTxt"></div>
            </div>
            <div class="dhxqItem wow animated fadeInUp">
                <p class="title">合作企业</p>
                <img class="triangle_icon" src="../assets/images/triangle_icon.png" alt="" />
                <div class="dhxqTxt"></div>
            </div>
        </div>
        <img class="bgImg" src="../assets/images/747x478.png" />
    </div>
</template>
<script>
import dataJson from "../assets/index.json";
export default {
    data() {
        return {
            dataJson,
        };
    },
};
</script>
<style lang="less" scoped>
@import url("../views/index.less");
#hzdw {
    margin-top: 23px;
    position: relative;
    width: 100%;
    .itemTitBox {
        margin: 0 auto;
        width: 363.5px;
        height: 138.5px;
        background: url("../assets/images/727x277.png") no-repeat;
        background-size: 100% 100%;
        text-align: center;
        box-sizing: border-box;
        padding-top: 40px;
        .big {
            font-size: 50px;
            font-family: MicrosoftYaHei;
            font-weight: bold;
            color: #ffffff;
        }
        .small {
            font-size: 24px;
            font-family: Century Gothic;
            font-weight: normal;
            color: #ffffff;
            font-style: italic;
            margin-top: 24px;
        }
    }
    .dhxq {
        position: relative;
        z-index: 2;
        box-sizing: border-box;
        padding: 14px 34px;
        margin: 0 auto;
        margin-top: 27px;
        width: 779px;
        // height: 439px;
        background: url("../assets/images/1558x877.png") no-repeat;
        background-size: 100% 100%;
        .dhxqItem {
            // display: flex;
            width: 100%;
            transition: all 0.6s;
            border-bottom: 1px solid #00fffc;
            // align-items: center;
            &:last-child {
                 border-bottom: none;
            }
            .title{
                font-size: 15px;
                font-family: MicrosoftYaHei;
                font-weight: 400;
                color: #FFFFFF;
                padding: 0 14px;
                line-height: 82px;
            }
            .triangle_icon {
                width: 11px;
                height: 15px;
                vertical-align: text-bottom;
            }
            .dhxqTxt {
                width: calc(100% - 180px);
                box-sizing: border-box;
                margin-left: 5px;
                padding: 25px 0;
                border-bottom: none;
                font-size: 15px;
                font-family: MicrosoftYaHei;
                font-weight: 400;
                color: #ffffff;
                line-height: 82px;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                .imgBox {
                    width: 109px;
                    height: 35.6px;
                    margin-left: 5px;
                    margin-bottom: 5px;
                    .img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
            &:last-child {
                .dhxqTxt {
                    border-bottom: none;
                }
            }
            &:hover {
                transform: scale(1.05);
            }
        }
    }
    .bgImg {
        width: 747px;
        height: 478px;
        position: absolute;
        right: 0;
        bottom: -154px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/hzdw.vue